import { CheckInput } from '../../../form/check-input/check-input';

export const onlyVerifiedOption: CheckInput<boolean> = {
    id: 'onlyVerified',
    name: 'onlyVerified',
    value: true,
};

export const onlyVerifiedLabel: string = 'REVIEWS.ONLY_VERIFIED.LABEL';
